// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { DdtsRoutingModule } from './ddts-routing.module';

// Custom packages - Components
import { DdtsListComponent } from 'src/app/modules/ddts/pages/ddts-list/ddts-list.page';
import { ChecklistDetailComponent } from './pages/checklist-detail/checklist-detail.page';
import { ChecklistListComponent } from './pages/checklist-list/checklist-list.page';
import { DdtDetailComponent } from './pages/ddt-detail/ddt-detail.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    DdtsRoutingModule,
    PublicModule,
  ],
  declarations: [
    DdtsListComponent,
    DdtDetailComponent,
    ChecklistListComponent,
    ChecklistDetailComponent
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class DdtsModule { }
